<template>
  <div class="d-flex flex-column pt-1">
    <p class="mb-0 v-input v-label" :class="focused ? 'primary--text' : ''" style="font-size: 11px !important;">
      {{ label }}
    </p>
    <DatePicker v-model="boundValue" type="datetime" :format="format" class="QDateTimeField3"
      :class="disabled ? 'removeunderline' : ''" :pickerOptions="pickerOptions"
      :placeholder="placeholder ? placeholder : 'Select date and time'" default-time="12:00:00" :readonly="disabled"
      :prefix-icon="' '" :clearable="clearable" size="small" @focus="handleFocus(true)" @blur="handleFocus(false)"
      @change="$emit('change')">
    </DatePicker>
  </div>
</template>


<script>
import { DatePicker } from 'element-ui';

export default {
  name: 'QDateTimeField3',
  props: {
    label: String,
    value: [String, Date],
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
  },
  components: {
    DatePicker
  },

  data() {
    return {
      focused: false,

      pickerOptions: {
        firstDayOfWeek: 1,
        /*
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
        */
      },
    };
  },

  methods: {
    handleFocus(e) {
      if (!this.disabled) {
        this.focused = e;
      }
    }
  },

  computed: {
    boundValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    format() {
      return this.$t('servicesystem.formatting.datetimeformat').replace('YYYY', 'yyyy').replace('DD', 'dd');
    }
  },

  watch: {},
};
</script>


<style lang='scss'>
.QDateTimeField3 {
  width: unset !important;
}

.QDateTimeField3 .el-input__inner {
  width: fit-content;
}

.QDateTimeField3 .el-input__inner {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px;
}

.QDateTimeField3.removeunderline .el-input__inner {
  border-bottom: none;
}

.el-time-panel {
  width: unset;
}
</style>